import './consignmentPickUp.css';
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col, NavItem, Table } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import { useState } from 'react';
// import { CommonRegistrationSidebar } from "../../common/common-registration-sidebar/commonRegistrationSidebar";
import { TextField } from '@mui/material';
import Grid from '@mui/material/Grid';
import { PROD } from '../../../common/constants';



function ConsignmentCB() {

   const navigate = useNavigate();

   const [urn, setUrn] = useState();
   const [showGrid, setShowGrid] = useState(false);
   const [showRB, setShowRB] = useState(false);
   const [showCB, setShowCB] = useState(false);

   const onAddBundle = (e) => {
      e.preventDefault();
      setShowGrid(true);
   }
   const onRawbamboo = (e) => {
      e.preventDefault();
      navigate("/ConsignmentPickUp");
   }
   // const onRawbamboo = (e) => {
   //    e.preventDefault();
   //    setShowRB(true);
   // }
   // const onChipedBamboo = (e) => {
   //    e.preventDefault();
   //    setShowCB(true);
   // }


   return (
      <div>
         <Container fluid>
            <Row>

               {/* <CommonRegistrationSidebar

backArrowClick={() => navigate("/dashboardStakeHolder")}

header=''

subHeader='Consignment Pick-up and Tracker'

registrationtype='Grower'

signOutClick={() => onSignOut()}

urnNumber={urn}

/> */}
               {/* <Col xs={12} md={3} className='common-internal-sidebar-col'>
                  <div className="common-internal-sidebar-container-cb">
                     <ArrowBackIosNew className="arrow-icon" onClick={() => (navigate('/dashboardStakeHolder'))} />
                  </div>
               </Col> */}
               <Col xs={12} md={12}>
               {!PROD &&  <p style={{textAlign:"center", fontSize:"2vh"}}>PIT38</p>}
                  <a className='addbundle-btn-asn-grn1' type='submit' onClick={(e) => onRawbamboo(e)}>Raw Bamboo</a><tab />
                  <div className='consignment-pick-up-div'>
                     <form>
                        <p className="headingStylePIT">Consignment Pick Up/Tracker</p>
                        <Container fluid>
                           <Row>
                              <Col xs={12} md={4}>
                                 <div className="consignment-pick-up-consignment-label" >Consignment No</div>
                                 <input className='consignment-pick-up-consignment-textfields' type="text" />
                              </Col>
                              <Col xs={12} md={4}>
                                 <div className="consignment-pick-up-consignment-label">Consignment Status</div>
                                 <input className='consignment-pick-up-textfields-disabled' type="text" disabled={true} />
                              </Col>
                           </Row>
                        </Container>
                        <Container fluid>
                           <Row>
                              <Col xs={12} md={4}>
                                 <div className="consignment-pick-up-label">Consignment Owner URN</div>
                                 <input className='consignment-pick-up-textfields-disabled' type="text" disabled={true} />
                                 <div className="consignment-pick-up-label">Consignment Owner Name</div>
                                 <input className='consignment-pick-up-textfields-disabled' type="text" disabled={true} />
                                 <div className="consignment-pick-up-label">Consignment Owner Contact</div>
                                 <input className='consignment-pick-up-textfields-disabled' type="text" disabled={true} />
                                 <div className="consignment-pick-up-label">Schedule Line</div>
                                 <input className='consignment-pick-up-textfields-disabled' type="text" disabled={true} />
                                 <div className="consignment-pick-up-label">Grower PO</div>
                                 <input className='consignment-pick-up-textfields-disabled' type="text" disabled={true} />
                                 <div className="consignment-pick-up-label">Pick-Up Location URN</div>
                                 <input className='consignment-pick-up-textfields-disabled' type="text" disabled={true} />
                                 <div className="consignment-pick-up-label">Pick-Up Location Name</div>
                                 <input className='consignment-pick-up-textfields-disabled' type="text" disabled={true} />
                              </Col>
                              <Col xs={12} md={4}>
                                 <div className="consignment-pick-up-label">Pick-Up Location Address</div>
                                 <input className='consignment-pick-up-textfields-disabled' type="text" disabled={true} />
                                 <div className="consignment-pick-up-label">Schedule Pick-Up Date</div>
                                 <input className='consignment-pick-up-textfields-disabled' type="text" disabled={true} />
                                 <div className="consignment-pick-up-label">Delivery Location URN</div>
                                 <input className='consignment-pick-up-textfields-disabled' type="text" disabled={true} />
                                 <div className="consignment-pick-up-label">Delivery Location Name</div>
                                 <input className='consignment-pick-up-textfields-disabled' type="text" disabled={true} />
                                 <div className="consignment-pick-up-label">Delivery Location Address</div>
                                 <input className='consignment-pick-up-textfields-disabled' type="text" disabled={true} />
                                 <div className="consignment-pick-up-label">Schedule Delivery Date</div>
                                 <input className='consignment-pick-up-textfields-disabled' type="text" disabled={true} />
                                 <div className="consignment-pick-up-label">Type of Inventory</div>
                                 <input className='consignment-pick-up-textfields-disabled' type="text" disabled={true} />
                              </Col>
                              <Col xs={12} md={4}>
                                 <div className="consignment-pick-up-label">Type Of Loading(FTL/LTL)</div>
                                 <input className='consignment-pick-up-textfields-disabled' type="text" disabled={true} />
                                 <div className="consignment-pick-up-label">Schedule consignment Weight (MT)</div>
                                 <input className='consignment-pick-up-textfields-disabled' type="text" disabled={true} />
                                 <div className="consignment-pick-up-label">Vehicle Registration</div>
                                 <input className='consignment-pick-up-textfields-disabled' type="text" disabled={true} />
                                 <div className="consignment-pick-up-label">Driver Name</div>
                                 <input className='consignment-pick-up-textfields-disabled' type="text" disabled={true} />
                                 <div className="consignment-pick-up-label">Driver ID</div>
                                 <input className='consignment-pick-up-textfields-disabled' type="text" disabled={true} />
                                 <div className="consignment-pick-up-label">Driver Contact</div>
                                 <input className='consignment-pick-up-textfields-disabled' type="text" disabled={true} />
                              </Col>
                           </Row>
                        </Container>
                        <Container fluid>
                           <Row>
                              <div className="consignment-pick-up-label">Comments If Any</div>
                              <TextField className='consignment-pick-up-comments-text-field' placeholder='Add comments' ></TextField>
                              <p className="consignment-pick-up-heading-labels">Select The Following Inspection Checklist</p>
                              <Col xs={12} md={5}>
                                 <p className="consignment-pick-up-radio-labels">Inspection Checklist</p>
                                 <div className="consignment-pick-up-radio-btn-div">
                                    <div className="consignment-pick-up-radio-yes-no">

                                       <input type="radio" name="isyes" value="yes" /> Yes{" "}
                                    </div>
                                    <div className="consignment-pick-up-radio-yes-no">

                                       <input type="radio" name="isyes" value="no" /> No{" "}
                                    </div>
                                 </div>
                                 <p className="consignment-pick-up-radio-labels">Proper Lashing</p>
                                 <div className="consignment-pick-up-radio-btn-div">
                                    <div className="consignment-pick-up-radio-yes-no">

                                       <input type="radio" name="isyes1" value="yes" /> Yes{" "}
                                    </div>
                                    <div className="consignment-pick-up-radio-yes-no">

                                       <input type="radio" name="isyes1" value="no" /> No{" "}
                                    </div>
                                 </div>
                                 <p className="consignment-pick-up-radio-labels">Payload With Capacity Limits</p>
                                 <div className="consignment-pick-up-radio-btn-div">
                                    <div className="consignment-pick-up-radio-yes-no">

                                       <input type="radio" name="isyes2" value="yes" /> Yes{" "}
                                    </div>
                                    <div className="consignment-pick-up-radio-yes-no">

                                       <input type="radio" name="isyes2" value="no" /> No{" "}
                                    </div>
                                 </div>
                                 <p className="consignment-pick-up-radio-labels">Payload Length Exceeding Limit</p>
                                 <div className="consignment-pick-up-radio-btn-div">
                                    <div className="consignment-pick-up-radio-yes-no">

                                       <input type="radio" name="isyes3" value="yes" /> Yes{" "}
                                    </div>
                                    <div className="consignment-pick-up-radio-yes-no">

                                       <input type="radio" name="isyes3" value="no" /> No{" "}
                                    </div>
                                 </div>
                                 <p className="consignment-pick-up-radio-labels">Payload Height Exceeding Limit</p>
                                 <div className="consignment-pick-up-radio-btn-div">
                                    <div className="consignment-pick-up-radio-yes-no">

                                       <input type="radio" name="isyes4" value="yes" /> Yes{" "}
                                    </div>
                                    <div className="consignment-pick-up-radio-yes-no">

                                       <input type="radio" name="isyes4" value="no" /> No{" "}
                                    </div>
                                 </div>
                              </Col>
                              <Col xs={12} md={6}>
                                 <div className="consignment-pick-up-label">Upload NOC From Village Head</div>
                                 <label class="chooseFile-create-rateCard">
                                    <input style={{ display: "none" }} type="file" accept="image/jpeg, image/jpg, image/png, .pdf" />Upload File
                                 </label>
                                 <div className="consignment-pick-up-label">Upload Transit pass from Forest Department</div>
                                 <label class="chooseFile-create-rateCard">
                                    <input style={{ display: "none" }} type="file" accept="image/jpeg, image/jpg, image/png, .pdf" />Upload File
                                 </label>
                                 <div className="consignment-pick-up-label">Type of Inventory to be picked</div>
                                 <select className='consignment-pick-up-dropdown-field'>
                                    <option>Select</option>
                                    <option>Raw Bamboo</option>
                                    <option>Chip Bamboo</option>
                                 </select>
                              </Col>

                              {/* <Col xs={12} md={9}>
                                        <form>
                                            <div>
                                                <p className='consignment-pick-up-heading-labels'>For Raw Bamboo Inventory</p>
                                                <Container fluid>
                                                   <Row>
                                                      <Col xs={12} md={6}>
                                                         <p className='consignment-pick-up-label'>Date of Harvesting</p>
                                                         <input className='consignment-pick-up-textfields' type="number" placeholder='Date of Harvesting' name="" ></input>
                                                         <p className='consignment-pick-up-label'>No. of Harvesters engaged</p>
                                                         <input className='consignment-pick-up-textfields' type="number" placeholder='No. of Harvesters engaged' name="" ></input>
                                                         <p className='consignment-pick-up-label'>Average Moisture during the pickup</p>
                                                         <input className='consignment-pick-up-textfields' type="number" placeholder='Average Moisture during the pickup' name="" ></input>
                                                         <p className='consignment-pick-up-label'>Age of bamboo (in years)</p>
                                                         <select className='consignment-pick-up-textfields'>
                                                            <option>Age of bamboo</option>
                                                            <option>greater than 4</option>
                                                            <option>less than 6</option>
                                                         </select>
                                                      </Col>
                                                      <Col xs={12} md={6}>
                                                         <p className="consignment-pick-up-label">Average wall thickness greater than xxx</p>
                                                            <div className="harvesting-radio-btn-div">
                                                            <div>
                                                               Yes{" "}
                                                               <input type="radio" name="isyes" value="yes"/>
                                                            </div>
                                                            <div className="harvesting-radio-yes-no">
                                                               No{" "}
                                                               <input type="radio" name="isyes" value="no"/>
                                                            </div>
                                                            </div>
                                                            <p className="consignment-pick-up-label">Average diameter greater than xxx</p>
                                                            <div className="harvesting-radio-btn-div">
                                                            <div>
                                                               Yes{" "}
                                                               <input type="radio" name="isyes" value="yes"/>
                                                            </div>
                                                            <div className="harvesting-radio-yes-no">
                                                               No{" "}
                                                               <input type="radio" name="isyes" value="no"/>
                                                            </div>
                                                            </div>
                                                            <p className="consignment-pick-up-label">Colour</p>
                                                            <select className="consignment-pick-up-textfields">
                                                            <option>Colour</option>
                                                            <option>Green</option>
                                                            <option>Grey</option>
                                                            </select>
                                                      </Col>
                                                      <p className='consignment-pick-up-heading-labels'>For bundle</p>
                                                      <Col xs={12} md={6}>
                                                            <p className='consignment-pick-up-label'>Barcode</p>
                                                            <input className='consignment-pick-up-textfields' type="number" placeholder='Barcode' name="" ></input>
                                                            <p className='consignment-pick-up-label'>Species Type</p>
                                                            <select className='consignment-pick-up-textfields'>
                                                               <option>Species Type</option>
                                                            </select>
                                                            <p className='consignment-pick-up-label'>Weight</p>
                                                            <input className='consignment-pick-up-textfields' type="number" placeholder='Weight' name="" ></input>
                                                            <button className='addbundle-btn-asn-grn' type='submit' onClick={(e) => onAddBundle(e)}>Add bundle</button>
                                                      </Col>
                                                      <Col xs={12} md={6}>
                                                         <p className='consignment-pick-up-label'>Average Moisture</p>
                                                         <input className='consignment-pick-up-textfields' type="number" placeholder='Average Moisture' name="" ></input>
                                                         <p className='consignment-pick-up-label'>No of poles</p>
                                                         <input className='consignment-pick-up-textfields' type="number" placeholder='No of poles' name="" ></input>
                                                      </Col>
                                                </Row>
                                                </Container>
                                                <Container fluid>
                                                   <Row>
                                                      <Col xs={12} md={12}>
                                                               <div className='dbs-table-div'>
                                                                     <Table responsive className="common-table" striped>
                                                                        <thead>
                                                                              <tr>
                                                                                 <th className='common-table-heading-text'>Barcode</th>
                                                                                 <th className='common-table-heading-text'>Species Type</th>
                                                                                 <th className='common-table-heading-text'>Weight</th>
                                                                                 <th className='common-table-heading-text'>Average Moisture</th>
                                                                                 <th className='common-table-heading-text'>No of poles</th>
                                                                              </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                              <tr>
                                                                                 <td className='common-table-text'>test</td>
                                                                                 <td className='common-table-text'>test</td>
                                                                                 <td className='common-table-text'>test</td>
                                                                                 <td className='common-table-text'>test</td>
                                                                                 <td className='common-table-text'>test</td>
                                                                              </tr>
                                                                        </tbody>
                                                                     </Table>
                                                               </div>
                                                                     }
                                                                     <Container fluid>
                                 <Row>
                                    <Col xs={12} md={5}>
                                       <div className="consignment-pick-up-label-1">Total Weight Pickup</div>
                                       <input className='consignment-pick-up-chip-bamboo-textfields-1' type="text" disabled={true}/>
                                       <br></br>
                                    </Col>
                                    <Col xs={12} md={5}>
                                       <div className="consignment-pick-up-label-1">Enter Odometer Start Reading</div>
                                       <input className='consignment-pick-up-chip-bamboo-textfields-1' type="text" disabled={true}/>
                                    </Col>          
                                 </Row>
                               </Container>   
                                                                    </Col>
                                                   </Row>
                                                </Container>
                                           </div>
                                       </form>
                                    </Col> */}
                              <p className='consignment-pick-up-heading-labels'>For Chipped Bamboo Inventory</p>
                              <Col xs={12} md={5}>
                                 <div className="consignment-pick-up-label">Tare Weight Measured @LLE</div>
                                 <input className='consignment-pick-up-chip-bamboo-textfields' type="text" placeholder='Tare Weight Measured @LLE' />
                                 <div className="consignment-pick-up-label">Avarage Moisture During The PickUp</div>
                                 <input className='consignment-pick-up-chip-bamboo-textfields' type="text" placeholder='Avarage Moisture During The PickUp' />
                                 <div className="consignment-pick-up-label">Avarage Chip Size</div>
                                 <input className='consignment-pick-up-chip-bamboo-textfields' type="text" placeholder="Avarage Chip Size" />
                              </Col>
                              <Col xs={12} md={5}>
                                 <div className="consignment-pick-up-label">Gross Weight Measured @LLE</div>
                                 <input className='consignment-pick-up-chip-bamboo-textfields' type="text" placeholder='Gross Weight Measured @LLE' />
                                 <div className="consignment-pick-up-label">Weight During Pickup</div>
                                 <input className='consignment-pick-up-chip-bamboo-textfields' type="text" placeholder='Weight During Pickup' />
                              </Col>
                           </Row>
                        </Container>
                        <Container fluid>
                           <Row>
                              <Col xs={12} md={5}>
                                 <div className="consignment-pick-up-label">Total Weight Pickup</div>
                                 <input className='consignment-pick-up-chip-bamboo-textfields-disabled' type="text" disabled={true} />
                                 <br></br>
                              </Col>
                              <Col xs={12} md={5}>
                                 <div className="consignment-pick-up-label">Enter Odometer Start Reading</div>
                                 <input className='consignment-pick-up-chip-bamboo-textfields' type="text" placeholder='Enter Odometer Start Reading' />
                              </Col>
                           </Row>
                        </Container>
                        <Col xs={12} md={2}>
                           <div className='submit-div-RB'>
                              <button className='submit-btn-RB' type='submit'>Save</button>

                              <button className='submit-btn-RB' type='submit'>Complete Loading & Start the Trip</button>
                           </div>
                        </Col>
                     </form>
                  </div>
               </Col>
            </Row>
         </Container>
      </div>
   )
}
export default ConsignmentCB;